// AppDetailPage.jsx
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import platformSolutions from "./platformSolutions";
import "./AppDetailPage.css";
import Header from './Header';
import Footer from './Footer';
import { FaArrowLeft, FaExternalLinkAlt, FaCheckCircle, FaBookOpen } from "react-icons/fa";

// Helper to convert any string to a URL-friendly slug
const slugify = (str) =>
  str
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')   // replace non-alphanumeric with hyphens
    .replace(/^-+|-+$/g, '');      // trim leading/trailing hyphens

function AppDetailPage() {
  const { productId, appId } = useParams();
  const navigate = useNavigate();
  const [appData, setAppData] = useState(null);
  const [productTitle, setProductTitle] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    // Find the product
    const product = platformSolutions.find((p) => p.id === productId);
    if (product && product.apps) {
      // Find the app – match by:
      // 1. exact app.id
      // 2. exact app.title (decoded from URL)
      // 3. slugified app.title (for pretty URLs)
      const app = product.apps.find((a) =>
        a.id === appId ||
        a.title === decodeURIComponent(appId) ||
        slugify(a.title) === appId
      );
      if (app) {
        setAppData(app);
        setProductTitle(product.title);
      }
    }
    setIsLoading(false);
  }, [productId, appId]);

  if (isLoading) {
    return (
      <div className="app-detail-container">
        <Header />
        <div className="app-detail-loading">
          <div className="loader"></div>
          <p>Loading app details...</p>
        </div>
        <Footer />
      </div>
    );
  }

  if (!appData) {
    return (
      <div className="app-detail-container">
        <Header />
        <div className="app-detail-not-found">
          <h2>App not found</h2>
          <p>The app you're looking for doesn't exist or has been moved.</p>
          <button onClick={() => navigate(-1)} className="app-detail-back-btn">
            <FaArrowLeft /> Go Back
          </button>
        </div>
        <Footer />
      </div>
    );
  }

  // const handleVisitMarketplace = () => {
  //   if (appData.link) {
  //     window.open(appData.link, "_blank", "noopener,noreferrer");
  //   }
  // };

  const handleMoreDetails = () => {
    if (appData.documentation) {
      window.open(appData.documentation, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div className="app-detail-container">
      <Header />
      
      <div className="app-detail-content">
        {/* Back Button */}
        <button onClick={() => navigate(-1)} className="app-detail-back-btn">
          <FaArrowLeft /> Back to {productTitle}
        </button>

        <div className="app-detail-card">
          <div className="app-detail-header">
            <div className="app-detail-image-wrapper">
              <img src={appData.image} alt={appData.title} className="app-detail-image" />
            </div>
            <div className="app-detail-info">
              <div className="app-detail-badge-wrapper">
                <span className="app-detail-badge">{productTitle}</span>
              </div>
              <h1 className="app-detail-title">{appData.title}</h1>
              <p className="app-detail-tagline">{appData.tagline}</p>
              
              <div className="app-detail-actions">
                {/* (optional action buttons) */}
              </div>
            </div>
          </div>

          <div className="app-detail-body">
            <div className="app-detail-section">
              <h2>About This App</h2>
              <p>{appData.tagline}</p>
            </div>

            <div className="app-detail-section">
              <h2>Key Features</h2>
              <ul className="app-detail-features">
                <li><FaCheckCircle /> Seamless integration with {productTitle}</li>
                <li><FaCheckCircle /> Easy to set up and configure</li>
                <li><FaCheckCircle /> Regular updates and support</li>
                <li><FaCheckCircle /> Optimized for performance</li>
              </ul>
            </div>

            <div className="app-detail-section">
              <h2>Why Choose This App?</h2>
              <p>
                This app is designed to enhance your {productTitle} experience by providing 
                powerful features that streamline your workflow and boost productivity. 
                Built with the latest technologies and best practices, it ensures reliability 
                and scalability for your business needs.
              </p>
            </div>

            {/* <div className="app-detail-cta">
              <button 
                className="app-detail-primary-btn"
                onClick={handleVisitMarketplace}
              >
                Get This App <FaExternalLinkAlt />
              </button>
              <button 
                className="app-detail-secondary-btn"
                onClick={handleMoreDetails}
              >
                <FaBookOpen /> More Details
              </button>
            </div> */}

            <div className="app-detail-cta">
<a
    href={appData.link}
    target="_blank"
    rel="noopener noreferrer"
    className="app-detail-primary-btn"
    onClick={() => {
      window.dataLayer = window.dataLayer || [];
 
      window.dataLayer.push({
        event: "get_this_app_click",
        product_name: appData.title
      });
    }}
>
    Get This App <FaExternalLinkAlt />
</a>
 
  <button
    className="app-detail-secondary-btn"
    onClick={handleMoreDetails}
>
<FaBookOpen /> More Details
</button>
</div>
 
 
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default AppDetailPage;